import React, { FC, useCallback, useEffect, useState } from 'react'
import ReactQuill from 'react-quill'

import 'react-quill/dist/quill.snow.css'

import { EditorProps } from './Editor.props'
import './Editor.scss'

const Editor: FC<EditorProps> = ({ modules, onChangeValue, placeholder = '', initialValue, onBlur }) => {
  const [value, setValue] = useState<string>('')

  const handleEditorValue = useCallback(
    (value) => {
      setValue(value)
      onChangeValue(value)
    },
    [onChangeValue]
  )

  const handleBlur = useCallback(() => {
    if (typeof onBlur === 'function') {
      onBlur(value)
    }
  }, [onBlur, value])

  useEffect(() => {
    if (initialValue?.length) setValue(initialValue)
  }, [initialValue])

  return (
    <ReactQuill
      className="quill-editor"
      modules={modules}
      theme="snow"
      value={value}
      onChange={handleEditorValue}
      onBlur={handleBlur}
      placeholder={placeholder}
    />
  )
}

export default Editor
